import { Typography } from '@mui/material';

export const CancellationFeeError = () => {
  return (
    <Typography
      variant="subtitle1"
      color="error"
      style={{ textAlign: 'center' }}
    >
      No pudimos obtener las políticas de cancelación
    </Typography>
  );
};
